// extracted by mini-css-extract-plugin
export default {"nav":"nav__f219d","back":"back__1SrC8","title":"title__2fC7D","subtitle":"subtitle__RkjYm","filter":"filter__umT5O"};